<template>
  <div>
    <div v-if="isFilterApplied" class="d-flex justify-content-end mb-3">
      <a href="javascript:;" class="btn btn-secondary w-60 display-6"  @click="handleClearFilters"> Clear Filters </a>
    </div>
  </div>
  <form @submit.prevent="handleFilters">
  <div class="row filter-row">
    
      
    <div class="col-sm-6 col-md-2 position-relative">

      <div class="input-block mb-3 form-focus select-focus ">
         <vue-select :style="`${ filters.employee_status && 'border-bottom: var(--primary-color) 2px solid;'}`" :options="employmentStatuses" placeholder="Select Status" id="design" v-model="filters.employee_status" :disabled="employmentStatusesLoading" @mouseenter.once="fetchEmploymentStatuses" />
          <label class="focus-label">Employement Status</label>
      </div>
        <i v-if="filters.employee_status" @click="handleClearOneFilter('employee_status')" class="fa-solid fa-x" :style="{position: 'absolute', top: '-20px', right: '0px', cursor: 'pointer'}"></i>
    </div>
    <div class="col-sm-6 col-md-2 position-relative">
      <div class="input-block mb-3 form-focus select-focus ">
        <vue-select :style="`${ filters.division && 'border-bottom: var(--primary-color) 2px solid;'}`" :options="divisions" v-model="filters.division"  placeholder="Select Division" id="design3" :disabled="divisionsLoading" @mouseenter.once="fetchDivisions" />
        <label class="focus-label">Division</label>
        
      </div>
      <i v-if="filters.division" @click="handleClearOneFilter('division')" class="fa-solid fa-x" :style="{position: 'absolute', top: '-20px', right: '0px', cursor: 'pointer'}"></i>
    </div>
    <div class="col-sm-6 col-md-2 position-relative">
      <div class="input-block mb-3 form-focus select-focus">
        <vue-select :style="`${ filters.department && 'border-bottom: var(--primary-color) 2px solid;'}`" :options="departments" v-model="filters.department" placeholder="Select Department" id="design2" :disabled="departmentsLoading" @mouseenter.once="fetchDepartments"  />
        <label class="focus-label">Department</label>
        
      </div>
      <i v-if="filters.department" @click="handleClearOneFilter('department')" class="fa-solid fa-x" :style="{position: 'absolute', top: '-20px', right: '0px', cursor: 'pointer'}"></i>
    </div>
    <div class="col-sm-6 col-md-2 position-relative">
      <div class="input-block mb-3 form-focus select-focus text-truncate ">
        <vue-select :style="`${ filters.campaign && 'border-bottom: var(--primary-color) 2px solid;'}`" :options="campaigns" v-model="filters.campaign" placeholder="Select Campaign" id="design4" :disabled="campaignsLoading" @mouseenter.once="fetchCampaigns" />
        <label class="focus-label">Campaign</label>
        
      </div>
      <i v-if="filters.campaign" @click="handleClearOneFilter('campaign')" class="fa-solid fa-x" :style="{position: 'absolute', top: '-20px', right: '0px', cursor: 'pointer'}"></i>
    </div>
    <div class="col-sm-6 col-md-2 position-relative">
      <div class="input-block mb-3 form-focus select-focus ">
        <vue-select :style="`${ filters.section && 'border-bottom: var(--primary-color) 2px solid;'}`" :options="sections" v-model="filters.section" placeholder="Select Section" id="design5" :disabled="sectionsLoading" @mouseenter.once="fetchSections" />
        <label class="focus-label">Section</label>
        
      </div>
      <i v-if="filters.section" @click="handleClearOneFilter('section')" class="fa-solid fa-x" :style="{position: 'absolute', top: '-20px', right: '0px', cursor: 'pointer'}"></i>
    </div>
    <div class="col-sm-6 col-md-2 position-relative">
      <div class="input-block mb-3 form-focus select-focus ">
        <vue-select :style="`${ filters.designation && 'border-bottom: var(--primary-color) 2px solid;'}`"  :options="designations" v-model="filters.designation" placeholder="Select Designation" id="design6" :disabled="designationsLoading" @mouseenter.once="fetchDesignations" />
        <label class="focus-label">Designation</label>
        
      </div>
      <i v-if="filters.designation" @click="handleClearOneFilter('designation')" class="fa-solid fa-x" :style="{position: 'absolute', top: '-20px', right: '0px', cursor: 'pointer'}"></i>
    </div>
    <div class="col-sm-6 col-md-2 position-relative">
      <div class="input-block mb-3 form-focus select-focus text-truncate">
        <vue-select :style="`${ filters.project && 'border-bottom: var(--primary-color) 2px solid;'}`" :options="projects" v-model="filters.project" placeholder="Select Project" id="design7" :disabled="projectsLoading" @mouseenter.once="fetchProjects" />
        <label class="focus-label">Project</label>
        
      </div>
      <i v-if="filters.project" @click="handleClearOneFilter('project')" class="fa-solid fa-x" :style="{position: 'absolute', top: '-20px', right: '0px', cursor: 'pointer'}"></i>
    </div>

    <div class="col-sm-6 col-md-2 position-relative">

      <div class="input-block mb-3 form-focus select-focus ">
         <vue-select :style="`${ filters.employee_wfh && 'border-bottom: var(--primary-color) 2px solid;'}`" :options="employmentWfhStatuses" placeholder="Select Status" id="design8" v-model="filters.employee_wfh" />
          <label class="focus-label">Employee WFH Status</label>
      </div>
        <i v-if="filters.employee_wfh" @click="handleClearOneFilter('employee_wfh')" class="fa-solid fa-x" :style="{position: 'absolute', top: '-20px', right: '0px', cursor: 'pointer'}"></i>
    </div>

    <div class="col-sm-6 col-md-2">
      <div class="input-block mb-3 form-focus" :class="{ focused: isFocused }">
        <input
          type="text"
          :style="`${ filters.employee_id && 'border-bottom: var(--primary-color) 2px solid;'}`"
          class="form-control floating"
          v-model="filters.employee_id"
          @focus="isFocused = true"
          @blur="isFocused = employee_id !== ''"
        />
        <label class="focus-label">Employee ID</label>
      </div>
    </div>
    <div class="col-sm-6 col-md-2">
      <div class="input-block mb-3 form-focus" :class="{ focused: isFocusedOn }">
        <input
          type="text"
          class="form-control floating"
          :style="`${ filters.employee_name && 'border-bottom: var(--primary-color) 2px solid;'}`"
          v-model="filters.employee_name"
          @focus="isFocusedOn = true"
          @blur="isFocusedOn = employee_name !== ''"
        />
        <label class="focus-label">Employee Name</label>
      </div>
    </div>
    <div class="col-sm-6 col-md-2">
      <div class="input-block mb-3 form-focus" :class="{ focused: isFocusedFirstName }">
        <input
          type="text"
          class="form-control floating"
          :style="`${ filters.first_name && 'border-bottom: var(--primary-color) 2px solid;'}`"
          v-model="filters.first_name"
          @focus="isFocusedFirstName = true"
          @blur="isFocusedFirstName = first_name !== ''"
        />
        <label class="focus-label">First Name</label>
      </div>
    </div>
    <div class="col-sm-6 col-md-2">
      <div class="input-block mb-3 form-focus" :class="{ focused: isFocusedLastName }">
        <input
          type="text"
          class="form-control floating"
          :style="`${ filters.last_name && 'border-bottom: var(--primary-color) 2px solid;'}`"
          v-model="filters.last_name"
          @focus="isFocusedLastName = true"
          @blur="isFocusedLastName = last_name !== ''"
        />
        <label class="focus-label">Last Name</label>
      </div>
    </div>
    <div class="col-sm-6 col-md-2">
      <div class="input-block mb-3 form-focus" :class="{ focused: isFocusedCnic }">
        <input
          type="text"
          class="form-control floating"
          :style="`${ filters.employee_cnic && 'border-bottom: var(--primary-color) 2px solid;'}`"
          v-model="filters.employee_cnic"
          @focus="isFocusedCnic = true"
          @blur="isFocusedCnic = employee_cnic !== ''"
        />
        <label class="focus-label">CNIC</label>
      </div>
    </div>
    <div class="col-sm-6 col-md-2">
      <div class="input-block mb-3 form-focus" :class="{ focused: isFocusedContact }">
        <input
          type="text"
          class="form-control floating"
          :style="`${ filters.employee_contact && 'border-bottom: var(--primary-color) 2px solid;'}`"
          v-model="filters.employee_contact"
          @focus="isFocusedContact = true"
          @blur="isFocusedContact = employee_contact !== ''"
          @input="filters.employee_contact = filters.employee_contact.replace(/[^0-9-+ ]/g, '')"
        />
        <label class="focus-label">Contact #</label>
      </div>
    </div>
     <div class="col-sm-6 col-md-2">
      <div class="input-block mb-3 form-focus" :class="{ focused: isFocusedEmail }">
        <input
          type="text"
          class="form-control floating"
          :style="`${ filters.employee_email && 'border-bottom: var(--primary-color) 2px solid;'}`"
          v-model="filters.employee_email"
          @focus="isFocusedEmail = true"
          @blur="isFocusedEmail = employee_email !== ''"
        />
        <label class="focus-label">Email</label>
      </div>
    </div>
     <div class="col-sm-6 col-md-2">
      <div class="input-block mb-3 form-focus" :class="{ focused: isFocusedPsuedoName }">
        <input
          type="text"
          class="form-control floating"
          :style="`${ filters.pseudo && 'border-bottom: var(--primary-color) 2px solid;'}`"
          v-model="filters.pseudo"
          @focus="isFocusedPsuedoName = true"
          @blur="isFocusedPsuedoName = pseudo !== ''"
        />
        <label class="focus-label">Pseudo Name</label>
      </div>
    </div>
    <div class="col-md-1">
    </div>
    <div class="d-flex col-sm-6 col-md-3 gap-2">
      <button type="submit" href="javascript:;" class="btn btn-success w-100"  @click.prevent="handleFilters"> Search </button>
      <button type="button" href="javascript:;" class="btn btn-success w-100"  @click.prevent="resetAllFilters"> Reset </button>
    </div>
    
  </div>
</form>
</template>

<script>
import EmploymentStatusService from '@/services/EmploymentStatusService';
import DepartmentService from '@/services/DepartmentService';
import DivisionService from '@/services/DivisionService';
import CampaignService from '@/services/CampaignService';
import SectionService from '@/services/SectionService';
import DesignationService from '@/services/DesignationService';
import EmployeeProjectService from '@/services/EmployeeProjectService';

export default {
  data() {
    return {
      select2: null,
      Company: ["Select Company", "Global Technologies", "Delta Infotech"],
      isFocused: false,
      filters:{
      employee_id: "",
      employee_name: "",
      first_name: "",
      last_name: "",
      employee_cnic:"",
      employee_contact:"",
      employee_email:"",
      pseudo:"",
      project:"",
      employee_status:"",
      employee_wfh:'',
      department: "",
      division: "",
      campaign: "",
      section: "",
      designation: ""
      },

      isFocusedOn: false,
      isFocusedFirstName: false,
      isFocusedLastName: false,
      isFocusedCnic:"",
      isFocusedContact:"",
      isFocusedEmail:"",
      isFocusedPsuedoName:"",
      isFocusedEmpStatus:"",
      selectedDesignation:"",
      employmentStatuses: [],
      employmentWfhStatuses: ['yes' , 'no'],
      departments:[],
      allDepartments: [],
      divisions: [],
      campaigns: [],
      projects: [],
      sections: [],
      designations:[],
      employmentStatusesLoading: false,
      employmentStatusesLoaded: false,
      departmentsLoading: false,
      departmentsLoaded: false,
      divisionsLoading: false,
      divisionsLoaded: false,
      campaignsLoading: false,
      campaignsLoaded: false,
      projectsLoading: false,
      projectsLoaded: false,
      sectionsLoading: false,
      sectionsLoaded: false,
      designationsLoading: false,
      designationsLoaded: false,
      searched: false,


    };
  },
  props:{
  },
  methods: {
    handleFilters(value) {
      
      //console.log(JSON.stringify(this.filters));
      this.searched = true;
      this.$emit('apply-filters', this.filters);
      // Perform any action on change
    },

    handleClearOneFilter(fileName) {
      this.filters[fileName] = "";
      const filtersHasProperty = Object.values(this.filters).filter(el => !!el).length;
      if(this.searched) {
        this.$emit('apply-filters', this.filters);
       }
      if(!filtersHasProperty) {
          this.searched = false
      }
    },

    resetAllFilters() {
      // Reset all filter values to empty strings
      Object.keys(this.filters).forEach(key => {
        this.filters[key] = "";
      });

      // Emit updated filters
      this.$emit("apply-filters", this.filters);

      // Reset search state
      this.searched = false;
    },

    async fetchEmploymentStatuses() {
            if (this.employmentStatusesLoading || this.employmentStatusesLoaded) return;
            this.employmentStatusesLoading = true;
            try {
                const response = await EmploymentStatusService.getStatuses();
                this.employmentStatuses = response?.data.map(el => ({id: el.id, text: el.status_name}));
                this.employmentStatusesLoaded = true;
            } catch (error) {
                console.error('Error fetching countries:', error);
            } finally {
                this.employmentStatusesLoading = false;
            }
        },

    async fetchDesignations() {
      if (this.designationsLoading || this.designationsLoaded) return;
      this.designationsLoading = true;
      try {
        const response = await DesignationService.getDesignations();
        this.designations = response?.data.map(el => ({id: el.id, text: el.designation_name}));
        this.designationsLoaded = true;
      } catch (error) {
        console.error('Error fetching designations:', error);
      } finally {
        this.designationsLoading = false;
      }
    },

    async fetchDivisions() {
      if (this.divisionsLoading || this.divisionsLoaded) return;
      this.divisionsLoading = true;
      try {
        const response = await DivisionService.getDivisions();
        this.divisions = response?.data.map(el => ({id: el.id, text: el.name}));
        this.divisionsLoaded = true;
      } catch (error) {
        console.error('Error fetching divisions:', error);
      } finally {
        this.divisionsLoading = false;
      }
    },

    async fetchDepartments() {
      if (this.departmentsLoading || this.departmentsLoaded) return;
      if (this.filters.division) return;
      this.departmentsLoading = true;
      try {
        const response = await DepartmentService.getDepartments();
        this.allDepartments = response?.data.map(el => ({id: el.id, text: el.name}));
        this.departments = this.allDepartments;
        this.departmentsLoaded = true;
      } catch (error) {
        console.error('Error fetching departments:', error);
      } finally {
        this.departmentsLoading = false;
      }
    },

    async fetchDepartmentsByDivision(divisionId) {
      this.departmentsLoading = true;
      try {
        const response = await DepartmentService.getDepartmentsDivisionWise(divisionId);
        this.departments = response?.data.map(el => ({id: el.id, text: el.name}));
      } catch (error) {
        console.error('Error fetching division-wise departments:', error);
      } finally {
        this.departmentsLoading = false;
      }
    },

    async fetchCampaigns() {
      if (this.campaignsLoading || this.campaignsLoaded) return;
      this.campaignsLoading = true;
      try {
        const response = await CampaignService.getCampaigns();
        this.campaigns = response?.data.map(el => ({id: el.id, text: el.campaigns}));
        this.campaignsLoaded = true;
      } catch (error) {
        console.error('Error fetching campaigns:', error);
      } finally {
        this.campaignsLoading = false;
      }
    },

    async fetchProjects() {
      if (this.projectsLoading || this.projectsLoaded) return;
      this.projectsLoading = true;
      try {
        const response = await EmployeeProjectService.fetch();
        this.projects = response?.data.map(el => ({id: el.id, text: el.project_name}));
        this.projectsLoaded = true;
      } catch (error) {
        console.error('Error fetching projects:', error);
      } finally {
        this.projectsLoading = false;
      }
    },

    async fetchSections() {
      if (this.sectionsLoading || this.sectionsLoaded) return;
      this.sectionsLoading = true;
      try {
        const response = await SectionService.getSections();
        this.sections = response?.data.map(el => ({id: el.id, text: el.section_name}));
        this.sectionsLoaded = true;
      } catch (error) {
        console.error('Error fetching sections:', error);
      } finally {
        this.sectionsLoading = false;
      }
    },

    handleClearFilters() {
      this.$emit('apply-filters', {});
      this.filters =  {
      employee_id: "",
      employee_name: "",
      first_name: "",
      last_name: "",
      employee_cnic:"",
      employee_contact:"",
      employee_email:"",
      pseudo:"",
      project:"",
      employee_status:"",
      employee_wfh:'',
      department: "",
      division: "",
      campaign: "",
      section: "",
      designation: ""};
      this.searched = false;

    }   
  },
 created() {
    this.searched = false
  },

  watch: {
    'filters.division'(newDivisionId) {
      if (newDivisionId) {
        this.fetchDepartmentsByDivision(newDivisionId);
      } else if (this.departmentsLoaded) {
        this.departments = this.allDepartments;
      } else {
        this.fetchDepartments();
      }
    }
  },

  computed: {
    isFilterApplied() {
        const filtersHasProperty = Object.values(this.filters).filter(el => !!el).length;

      return this.searched && filtersHasProperty
    }

    
  },


};
</script>
